import { render, staticRenderFns } from "./value-percent.vue?vue&type=template&id=d4c207b8&scoped=true&"
import script from "./value-percent.vue?vue&type=script&lang=js&"
export * from "./value-percent.vue?vue&type=script&lang=js&"
import style0 from "./value-percent.vue?vue&type=style&index=0&id=d4c207b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c207b8",
  null
  
)

export default component.exports